import { getUrl, getSSIUrl } from "@xo-union/dist-url";
var DIST_NAME = 'tk-pagelet-header-nav';
export var getHeaderAssetUrl = function getHeaderAssetUrl(tag, path) {
  return getUrl({
    params: {
      name: DIST_NAME,
      tag: tag,
      path: path
    }
  });
};
export var getHeaderSSIUrl = function getHeaderSSIUrl(tag, path) {
  return getSSIUrl({
    params: {
      name: DIST_NAME,
      tag: tag,
      path: path
    }
  });
};